import React from "react";
import { useMusicPlayer } from "./musicPlayerContext";

const MusicButton = () => {
  const { hasMusic, toggleMusic, isPlaying } = useMusicPlayer();

  return (
    <div className="music-player-button">
      <button className={hasMusic ? "" : "inactive"} onClick={toggleMusic}>
        <img
          src={isPlaying ? require("../assets/img/unmuted.svg") : require("../assets/img/muted.svg")}
          alt={isPlaying ? "mute" : "unmute"}
        />
      </button>
    </div>
  );
};

export default MusicButton;
